import { Component, h, ComponentInterface, Host, Prop } from '@stencil/core';

@Component({
  tag: 'signet-card',
  styleUrl: 'signet-card.scss',
})
export class SignetCard implements ComponentInterface {
  /** Card title */
  @Prop() cardTitle?: string;
  /** Card subtitle */
  @Prop() cardSubtitle?: string;
  /** Card body text */
  @Prop() cardBody?: string;
  /** Card footer text */
  @Prop() cardFooter?: string;
  /** Card icon name (for SignetIcon) */
  @Prop() cardIcon?: string;
  /** Card icon variant */
  @Prop() cardIconVariant?: 'default' | 'sharp' | 'outlined' | 'round' | 'two-tone' = 'default';
  /** Card image src */
  @Prop() imageSrc?: string;
  /** Card variant */
  @Prop() variant?: 'filled' | 'outlined' = 'filled';
  /** Button label */
  @Prop() buttonLabel?: string;
  /** Button type */
  @Prop() buttonType?: 'button' | 'submit' | 'reset' = 'button';
  /** Button style */
  @Prop() buttonClass?: 'primary' | 'text' | 'outlined' = 'primary';
  /** Actions: array of button configs */
  @Prop() actions?: Array<{ label: string; type?: 'button' | 'submit' | 'reset'; class?: 'primary' | 'text' | 'outlined'; }>;

  render() {
    const classes = {
      'signet-card': true,
      [`signet-card--${this.variant}`]: !!this.variant,
    };

    return (
      <Host class={classes}>
        <div class="card-content">
          {this.imageSrc && (
            <img src={this.imageSrc} alt="Card image" class="card-image" />
          )}
          <div class="card-body">
            {(this.cardIcon || this.cardTitle || this.cardSubtitle) && (
              <header class="body-header">
                {this.cardIcon && (
                  <signet-icon icon={this.cardIcon} variant={this.cardIconVariant}></signet-icon>
                )}
                {this.cardTitle && <h3 class="heading">{this.cardTitle}</h3>}
                {this.cardSubtitle && <div class="subheading">{this.cardSubtitle}</div>}
              </header>
            )}
            {this.cardBody && <div class="body-text">{this.cardBody}</div>}
            <slot />
            {this.buttonLabel && (
              <signet-button type={this.buttonType} class={this.buttonClass}>{this.buttonLabel}</signet-button>
            )}
            {Array.isArray(this.actions) && this.actions.length > 0 && (
              <div class="card-actions">
                {this.actions.map(action => (
                  <signet-button type={action.type || 'button'} class={action.class || 'primary'}>{action.label}</signet-button>
                ))}
              </div>
            )}
          </div>
          {this.cardFooter && (
            <div class="card-footer">{this.cardFooter}</div>
          )}
        </div>
      </Host>
    );
  }
}
